module.exports = __webpack_public_path__ + "img/banner2026m_th.c2fe3b00.webp";